import { useState } from "react";
import { toast } from "sonner";
import { MailWarning, X } from "lucide-react";
import api, { apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function VerifyBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || user.email_verified || user.auth_provider !== "email" || dismissed) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Tautan verifikasi baru sudah dikirim ke emailmu. Cek inbox/spam ya!");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="verify-banner" className="bg-su-energy/15 border-b-2 border-su-energy/40">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3 flex-wrap">
        <MailWarning className="w-5 h-5 text-su-energy shrink-0" />
        <p className="text-sm font-semibold text-su-text flex-1 min-w-[180px]">
          Emailmu belum diverifikasi. Verifikasi untuk mengamankan akunmu.
        </p>
        <button
          data-testid="verify-banner-resend"
          onClick={resend}
          disabled={busy}
          className="text-sm font-heading font-extrabold text-su-primary hover:underline disabled:opacity-50"
        >
          {busy ? "Mengirim..." : "Kirim ulang tautan"}
        </button>
        <button data-testid="verify-banner-dismiss" onClick={() => setDismissed(true)} className="text-su-muted hover:text-su-text">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
